import { createMemoryHistory, createRouter as createVueRouter, createWebHistory } from 'vue-router';
import RouteHandler from './RouteHandler.vue';
import type { AppContext } from './types';

const routePatterns = [
    '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute(.*)*',
    '/:lang([a-z]{2})/:sitecoreRoute(.*)*',
    '/:sitecoreRoute(.*)*'
];

const createRouter = (isSSR?: boolean, appContext?: AppContext) => {
    const base =
        !appContext?.sitecoreVirtualFolder || appContext?.sitecoreVirtualFolder === '/'
            ? appContext?.routerBase
            : appContext?.sitecoreVirtualFolder.replace(/\/$/, '') + appContext?.routerBase;

    return createVueRouter({
        history: isSSR ? createMemoryHistory(base) : createWebHistory(base),
        routes: routePatterns.map(routePattern => {
            return {
                path: routePattern,
                component: RouteHandler,
                props: route => ({ route })
            };
        })
    });
};
export default createRouter;
